// @core/api/endpoints/product/delete_product_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/product';

/**
 * Delete product category
 * Deletes a product category. Products in this category will become uncategorized.
 */
export async function DeleteProductCategory(
  category_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/categories/:category_id`;
  requestPath = requestPath.replace(':category_id', encodeURIComponent(category_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
